module.exports = __webpack_public_path__ + "static/assets/2b0cfb89b2c8d1badb03136fcf911c3b.mp3";